import { useAppContext } from "../../../../AppContext";
import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { IMyReservationsViewModelWrapper } from "../../myReservations/models/MyReservationsViewModelWrapper";

export const usePrefetchMyReservations = () => {
  const { selectedStudio, currentUser } = useAppContext();

  useApiQuery<IMyReservationsViewModelWrapper>({
    queryKey: [endpointsMetadata.myReservations.getAll],
    endpoint: endpointsMetadata.myReservations.getAll,
    enabled: !!currentUser?.id && !!selectedStudio && selectedStudio.id > 0,
    disableErrorToast: true,
    retry: false,
    globalIsLoading: false,
  });
};
